module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_25-Grey-c42da865a31075efb8aff3960b1ad13e.png";